import Vue from "vue";
import Vuex from "vuex";

import config from "./modules/config";
import course from "./modules/course/course";
import auth from "./modules/auth/auth";
import category from "./modules/category/category";
import shopingCart from "./modules/shop/shop";
import menu from "./modules/menu";
import comment from "./modules/comments";
import lessons from "./modules/lessons";

// v2 
import project from "../v2/src/store/modules/project/"
import userCourses from "../v2/src/store/modules/userCourses/"
import categories from "../v2/src/store/modules/categories/"
import allcourses from "../v2/src/store/modules/allcourses/"
import logout from "../v2/src/store/modules/logout/"
import suggestedCourses from "../v2/src/store/modules/suggestedCourses/"
import getUser from "../v2/src/store/modules/getUser/"
import categoryCourses from "../v2/src/store/modules/categoryCourses/"
import userImageProfile from "../v2/src/store/modules/userImageProfile/"
import updateUser from "../v2/src/store/modules/updateUser/"
import invoices from "../v2/src/store/modules/invoices/"
import detailCourse from "../v2/src/store/modules/detailCourse/"
import updatePassword from "../v2/src/store/modules/updatePassword/"
import notes from "../v2/src/store/modules/notes/";
import questions from "../v2/src/store/modules/questions/";
import progress from "../v2/src/store/modules/progress/";
import courses, { STORE_NAME_COURSES } from "../v2/src/store/modules/courses"
import mentories, { STORE_NAME_MENTORIES } from "../v2/src/store/modules/mentories"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    config,
    category,
    course,
    [STORE_NAME_COURSES ]: courses,
    [STORE_NAME_MENTORIES ]: mentories,
    // shopingCar,
    shopingCart,
    menu,
    comment,
    lessons,
    project,
    userCourses,
    categories,
    allcourses,
    logout,
    suggestedCourses,
    getUser,
    categoryCourses,
    userImageProfile,
    invoices,
    updateUser,
    detailCourse,
    updatePassword,
    notes,
    questions,
    progress
  },
});
